import { render, staticRenderFns } from "./resellRecord.vue?vue&type=template&id=c079c082&scoped=true&"
import script from "./resellRecord.vue?vue&type=script&lang=js&"
export * from "./resellRecord.vue?vue&type=script&lang=js&"
import style0 from "./resellRecord.vue?vue&type=style&index=0&id=c079c082&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c079c082",
  null
  
)

export default component.exports